import { render, staticRenderFns } from "./BookingSearch.vue?vue&type=template&id=fd3d8874&scoped=true"
import script from "./BookingSearch.vue?vue&type=script&lang=js"
export * from "./BookingSearch.vue?vue&type=script&lang=js"
import style0 from "./BookingSearch.vue?vue&type=style&index=0&id=fd3d8874&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "fd3d8874",
  null
  
)

export default component.exports